/**
 * panelRegistry.js — the Titan Treasure dashboard's tabs, in display order.
 *
 * The dashboard builds its tab bar, URLs (/titan-reporting/<key>) and
 * descriptions from this list. To add a panel:
 *   1. add a DAO method to fraud_rules_management/idenza_tt_reporting_dao.py
 *      (build it on self._with_tx() so outcomes are counted the same way)
 *   2. expose it with @tt_endpoint in onboarding_services/routes/tt_reporting_route.py
 *   3. write panels/<Name>Panel.jsx; it receives { win, fresh, openAccount, openRing }
 *   4. add an entry below
 *
 * `allTime: true` hides the time-window selector for that panel.
 */
import SummaryPanel from "./panels/SummaryPanel";
import UserInvestigationPanel from "./panels/UserInvestigationPanel";
import BlacklistPanel from "./panels/BlacklistPanel";
import RingsPanel from "./panels/RingsPanel";
import CardsPanel from "./panels/CardsPanel";
import DecisionRatesPanel from "./panels/DecisionRatesPanel";
import DisputesPanel from "./panels/DisputesPanel";
import ControlSetPanel from "./panels/ControlSetPanel";

export const TT_PANELS = [
  {
    key: "summary",
    label: "Summary",
    description: "How much came in, how much was stopped, and how much fraud got through.",
    component: SummaryPanel,
  },
  {
    key: "users",
    label: "User investigation",
    description: "Everything we know about one account, with a redemption verdict.",
    component: UserInvestigationPanel,
    allTime: true,
  },
  {
    key: "blacklist",
    label: "Blacklist",
    description: "Every blacklisted account: what it deposited, what issuers refused, and who it is linked to.",
    component: BlacklistPanel,
    allTime: true,
  },
  {
    key: "rings",
    label: "Fraud rings",
    description: "Accounts tied together by a shared device or a card passed between them.",
    component: RingsPanel,
    allTime: true,
  },
  {
    key: "cards",
    label: "Cards",
    description: "How cards move between accounts, and how each card range is behaving.",
    component: CardsPanel,
  },
  {
    key: "decision-rates",
    label: "Decision rates",
    description: "What happens to a deposit: approved, blocked, declined by the bank or abandoned.",
    component: DecisionRatesPanel,
  },
  {
    key: "disputes",
    label: "Disputes",
    description: "Chargebacks from Finix: what needs a response, what was won and lost, and who they came from.",
    component: DisputesPanel,
    allTime: true,
  },
  {
    key: "controls",
    label: "Control set",
    description: "Every control on this merchant: where it acts, who owns it and whether it is live.",
    component: ControlSetPanel,
    allTime: true,
  },
];

export const panelByKey = (key) => TT_PANELS.find((p) => p.key === key) || TT_PANELS[0];
